































import { SfButton, SfInput } from '@storefront-ui/vue';
import {
  computed,
  ref,
  defineComponent,
  useRoute,
  watch,
  nextTick
} from '@nuxtjs/composition-api';
import { cartGetters } from '@wemade-vsf/checkout';
import { useCart } from '@wemade-vsf/customer';

export default defineComponent({
  name: 'CouponCode',
  components: {
    SfButton,
    SfInput,
  },
  setup(props, { emit }) {
    const {
      cart, applyCoupon, removeCoupon, error,
    } = useCart();
    const route = useRoute();

    const couponCodeUserInput = ref('');
    const isButtonDisabled = ref(!cartGetters.getAppliedCoupon(cart.value)?.code);
    const couponCodeAppliedToCart = computed(() => cartGetters.getAppliedCoupon(cart.value)?.code);
    const isCouponCodeApplied = computed(() => couponCodeAppliedToCart.value !== undefined);
    const hasAnyError = computed(() => Object.values(error.value).some((value) => value !== null));
    const applyCouponMsg = computed<Error>(() => error.value.applyCoupon || error.value.removeCoupon || { message: '', name: 'apply-coupon' });
    
    const applyOrRemoveCoupon = async () => {
      isButtonDisabled.value = true; 
      const wasApplied = isCouponCodeApplied.value; 

      const operationPromise = isCouponCodeApplied.value
        ? removeCoupon({})
        : applyCoupon({ couponCode: couponCodeUserInput.value });
      await operationPromise;
      couponCodeUserInput.value = '';
      emit('cartUpdated');

      await nextTick();

      
      if (
        route.value.fullPath.includes('sveacheckout') &&
        !error.value.applyCoupon &&
        (
          (!wasApplied && isCouponCodeApplied.value) ||
          (wasApplied && !isCouponCodeApplied.value)   
        )
      ) {
        window.location.reload();
      }

      if (isCouponCodeApplied.value) {
        isButtonDisabled.value = false;
      } else {
        isButtonDisabled.value = !couponCodeUserInput.value;
      }
    };

    watch(isCouponCodeApplied, (applied) => {
      isButtonDisabled.value = applied ? false : !couponCodeUserInput.value;
    }, { immediate: true });

    watch([couponCodeUserInput, isCouponCodeApplied], () => {
      if (isCouponCodeApplied.value) {
        isButtonDisabled.value = false; 
      } else {
        isButtonDisabled.value = !couponCodeUserInput.value; 
      }
    });

    return {
      couponCodeUserInput,
      couponCodeAppliedToCart,
      isCouponCodeApplied,
      applyCouponMsg,
      applyOrRemoveCoupon,
      hasAnyError,
      isButtonDisabled
    };
  },
});
